export const AUTO_SAVE_DEBOUNCE_MS = 1000;
